// Gemeinsame Ein-/Ausblende aller Seiten beim Seitenwechsel: kurz und nur über die Deckkraft
// (kein Verschieben — die Leiste oben und feste Elemente sollen nicht mitwackeln).
// Die Leiste selbst (FloatingHeader) hängt per Portal in <body> und blendet deshalb nicht mit.
// Zusammen mit AnimatePresence mode="wait" in App.js: 0,12 s aus, 0,25 s ein.
export const SEITEN_BLENDE = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.25, ease: [0.22, 1, 0.36, 1] } },
  exit: { opacity: 0, transition: { duration: 0.12, ease: 'easeIn' } },
};
